var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriority4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#c60000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0919748,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "M12.117 6.54a1.275 1.275 0 0 0-.662.185L4.81 10.762a1.275 1.275 0 0 0-.428 1.75 1.275 1.275 0 0 0 1.751.429l5.985-3.636 5.985 3.636a1.275 1.275 0 0 0 1.75-.428 1.275 1.275 0 0 0-.427-1.751L12.78 6.725a1.275 1.275 0 0 0-.662-.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#de0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0919748,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "M12.195 11.807a1.275 1.275 0 0 0-.662.185l-6.646 4.037a1.275 1.275 0 0 0-.428 1.751 1.275 1.275 0 0 0 1.751.428l5.985-3.635 5.985 3.635a1.275 1.275 0 0 0 1.75-.428 1.275 1.275 0 0 0-.427-1.75l-6.646-4.038a1.275 1.275 0 0 0-.662-.185z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority4);
export default __webpack_public_path__ + "static/media/priority-4.b148e3a93cea7d4404156579d543f8ac.svg";
export { ForwardRef as ReactComponent };